'use client';

import { MdMailOutline, MdPhone } from 'react-icons/md';
import { useGetEmployeesQuery } from '@api/api';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import LoadingSkeletonCategory from '@components/loadingSkeletons/loadingSkeletonCategory';
import MailButton from '@components/MailButton';
import PhoneButton from '@components/PhoneButton';

export default function Employees({
  onlyAdvisors = false,
  className = '',
}: {
  onlyAdvisors?: boolean;
  className?: string;
}) {
  const t = useTranslations('page.contact');
  const { data, isFetching } = useGetEmployeesQuery(true);
  return (
    <>
      {isFetching && (
        <div className={`${className}`}>
          <LoadingSkeletonCategory />
        </div>
      )}
      {!isFetching && !!data?.data?.length && (
        <div
          className={`relative grid grid-cols-1 gap-x-10 gap-y-12 sm:grid-cols-2 md:grid-cols-3 ${className}`}
        >
          {data.data.map((employee: any) => {
            if (onlyAdvisors && !employee.sales_advisor) {
              return null;
            }
            return (
              <div
                key={employee.id}
                className='flex w-full grow flex-col gap-1 border border-brand p-6 text-brand'
              >
                {employee.image && (
                  <div className='relative mb-2 aspect-square'>
                    <Image
                      src={employee.image}
                      alt={employee.name}
                      fill={true}
                      className='w-full object-cover grayscale'
                    />
                  </div>
                )}
                <h3 className='text-2xl font-bold'>{employee.name}</h3>
                <span
                  className={`whitespacing-pre min-h-[theme('spacing[12]')] font-semibold text-white`}
                >
                  {employee.title}
                </span>
                <div className='mt-1 flex flex-col gap-3'>
                  {employee.cellphone && (
                    <PhoneButton number={employee.cellphone} theme='green' />
                  )}
                  {employee.email && (
                    <MailButton mail={employee.email} theme='green' />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
